export const EVENT_FLOW_FIELD_LABELS: Record<string, string> = {
  url: 'Url Address',
  method: 'Method',
  authMethod: 'Authentication',
  authUsername: 'Username',
  authPassword: 'Password',
  provider: 'Provider',
  language: 'Language',
  model: 'Model',
  summarySystemPrompt: 'Summary System Prompt',
  summaryUserPrompt: 'Summary User Prompt',
  skipStorage: "Don't Store Transcription",
  incomingAnsweredReasonId: 'Incoming/Answered Reason',
  incomingMissedReasonId: 'Incoming/Missed Reason',
  incomingMailboxReasonId: 'Incoming/Mailbox Reason',
  outgoingAnsweredReasonId: 'Outgoing/Answered Reason',
  outgoingMissedReasonId: 'Outgoing/Missed Reason',
  incomingAnsweredNoteId: 'Incoming/Answered Note',
  incomingMissedNoteId: 'Incoming/Missed Note',
  incomingMailboxNoteId: 'Incoming/Mailbox Note',
  outgoingAnsweredNoteId: 'Outgoing/Answered Note',
  outgoingMissedNoteId: 'Outgoing/Missed Note',
  noteTemplate: 'Note Template',

  // Added from EVENT_FILTER_OPTIONS:
  callType: 'Call Type',
  callStatus: 'Call Status',
  fromNumber: 'From Number',
  toNumber: 'To Number',
  extension: 'Extension',
  callFromAni: 'Call From ANI',
  callToAni: 'Call To ANI',
  'recordings.account': 'Account',
  'recordings.extension': 'Extension',
};
